import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress,
  Alert,
  Pagination,
  PaginationItem,
  TextField,
  InputAdornment,
  Drawer,
  Tabs,
  Tab,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InputIcon from '@mui/icons-material/Input';
import TimerIcon from '@mui/icons-material/Timer';
import Navbar from "../components/Navbar.js";
import { backendRoot } from "../config";
import BelleImg from "../assets/738Belle.png";
import TourmalineImg from "../assets/5616Tourmaline.png";
import EnfieldImg from "../assets/7114Enfield.png";
import ModestoImg from "../assets/6907Modesto.png";
import RamhornImg from "../assets/4706Ramhorn.png";
import ThomsonDrImg from "../assets/ThomsonDr.png";
import RamhornKilleenImg from "../assets/4706RamhornKilleen.png";
import OtterImg from "../assets/1059Otter.png";
import WolverineImg from "../assets/1013Wolverine.png";
import TourmalineKilleenImg from "../assets/5616TKilleen.png";

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`transaction-tabpanel-${index}`}
      aria-labelledby={`transaction-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function Transactions() {
  // Hardcoded transaction data
  const [transactions, setTransactions] = useState([
    {
      id: 1,
      order_number: "KS1100007221",
      order_due_date: "",
      ticket_id: "IQ-88770",
      bsw_due_date: "2025-10-22 19:46:29",
      terminal_id: "TML.002.02aaa.01.3.2",
      address_id: "047166441403524",
      full_address: "2110 THOMPSON DR JUNCTION CITY KS 66441",
      received_date_time: "2025-10-13 19:46:29",
      processed_date_time: "2025-10-14 08:30:00",
      status: "Not Processed",
      terminal: { longitude: -96.855002332487, latitude: 39.044875052694 },
      building: { longitude: -96.8551635742187, latitude: 39.045166015625 }
    },
    {
      id: 2,
      order_number: "TX1100041501",
      order_due_date: "",
      ticket_id: "IQ-415001",
      bsw_due_date: "2025-10-15 14:30:00",
      terminal_id: "TML.004.04.01.5.2",
      address_id: "415000000789012",
      full_address: "4706 RAMHORN KILLEEN TX 76542",
      received_date_time: "2025-10-01 14:30:00",
      processed_date_time: "2025-10-02 09:15:00",
      status: "Not Processed",
      terminal: { longitude: -97.68930956570574, latitude: 31.058856178659937 },
      building: { longitude: -97.68914795, latitude: 31.058969497680664 }
    },
    {
      id: 3,
      order_number: "SC1100011208",
      order_due_date: "",
      ticket_id: "IQ-313161",
      bsw_due_date: "2025-10-17 17:52:36",
      terminal_id: "TML.002.05.04.1.1",
      address_id: "140029902418122",
      full_address: "1059 OTTER CIR BEAUFORT SC 29902",
      received_date_time: "2025-10-07 17:52:36",
      processed_date_time: "2025-10-08 10:45:00",
      status: "Not Processed",
      terminal: { longitude: -80.716532484087, latitude: 32.412911707024 },
      building: { longitude: -80.717606, latitude: 32.412952 }
    },
    {
      id: 4,
      order_number: "SC1100011103",
      order_due_date: "",
      ticket_id: "IQ-313176",
      bsw_due_date: "2025-10-17 19:21:20",
      terminal_id: "TML.002.05.04.5.2",
      address_id: "140029902414312",
      full_address: "1013 WOLVERINE DR BEAUFORT SC 29902",
      received_date_time: "2025-10-07 19:21:20",
      processed_date_time: "2025-10-08 11:30:00",
      status: "Not Processed",
      terminal: { longitude: -80.714690984601, latitude: 32.415250052263 },
      building: { longitude: -80.714874, latitude: 32.415283 }
    },
    {
      id: 5,
      order_number: "TX1100015421",
      order_due_date: "",
      ticket_id: "IQ-313089",
      bsw_due_date: "2025-10-07 07:44:05",
      terminal_id: "TML.003.05a.03.1.3",
      address_id: "147576542319621",
      full_address: "5616 TOURMALINE DR KILLEEN TX 76542",
      received_date_time: "2025-09-27 07:44:05",
      processed_date_time: "2025-09-28 14:20:00",
      status: "Not Processed",
      terminal: { longitude: -97.691620971331, latitude: 31.051809285877 },
      building: { longitude: -97.691823, latitude: 31.051597 }
    }
  ]);

  const [loading, setLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [transactionsPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [rightPanelOpen, setRightPanelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [transactionDesignDetails, setTransactionDesignDetails] = useState(null);
  const [terminalAddressDetails, setTerminalAddressDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // Summary is derived from transactions; no separate summary state
  const [submittingTransactions, setSubmittingTransactions] = useState(new Set());
  const [processedTransactions, setProcessedTransactions] = useState(new Set());
  const navigate = useNavigate();

  // Filter summary data based on date range
   const getFilteredTransactionsByDate = () => {
     if (!startDate && !endDate) return transactions;
     const toDateOnly = (dt) => (dt ? String(dt).split(' ')[0] : '');
     return transactions.filter(t => {
       const date = toDateOnly(t.received_date_time);
       if (!date) return false;
       if (startDate && endDate) return date >= startDate && date <= endDate;
       if (startDate) return date >= startDate;
       if (endDate) return date <= endDate;
      return true;
    });
  };

  // Calculate summary KPIs
  const calculateSummaryKPIs = () => {
    const items = getFilteredTransactionsByDate();
    const totalTickets = items.length;
    const processedItems = items.filter(i => String(i.status).toLowerCase() === 'processed');
    const totalCompleted = processedItems.length;
    const totalFailed = 0;

    // Avg processing time hardcoded to 32 seconds
    const avgProcessingTimeSec = 32;

    return {
      totalInputCount: totalTickets,
      totalProcessCount: totalCompleted,
      totalTickets,
      totalCompleted,
      totalFailed,
      avgProcessingTime: Math.round(avgProcessingTimeSec),
      processingEfficiency: totalTickets ? ((totalCompleted / totalTickets) * 100).toFixed(1) : '0.0'
    };
  };

  const summaryKPIs = calculateSummaryKPIs();

  const handleRowClick = (transactionId) => {
    // Find the selected transaction
    const transaction = transactions.find(t => t.id === transactionId);
    if (transaction && String(transaction.status).toLowerCase() === 'processed') {
      setSelectedTransaction(transaction);
      setRightPanelOpen(true);
      setActiveTab(0);
      setDetailsLoading(false);
      if (transaction.id === 1) {
        setTransactionDesignDetails({
          row_id: 471664414,
          address_id: '047166441403524',
          status: 'success',
          cost: 0,
          flowerpots: 1,
          fp_id: 'FP001',
          map_url: '',
          building_id: 152152,
          converted_image: ThomsonDrImg,
          imagebase64: '',
          version_id: 1,
          is_current: true,
          summary_date: 'N/A'
        });
        setTerminalAddressDetails({
          row_num: 1,
          ticket_id: 'IQ-88770',
          terminal_id: 'TML.002.02aaa.01.3.2',
          address_id: '047166441403524',
          addr1: '2110 THOMPSON DR JUNCTION CITY KS 66441',
          addr1_lat: 39.045166015625,
          addr1_long: -96.8551635742187,
        });
      } else if (transaction.id === 2) {
        setTransactionDesignDetails({
          row_id: 415001,
          address_id: '415000000789012',
          status: 'success',
          cost: 0,
          flowerpots: 0,
          fp_id: 'FP001',
          map_url: '',
          building_id: 415415,
          converted_image: RamhornKilleenImg,
          imagebase64: '',
          version_id: 1,
          is_current: true,
          summary_date: 'N/A'
        });
        setTerminalAddressDetails({
          row_num: 2,
          ticket_id: 'IQ-415001',
          terminal_id: 'TML.004.04.01.5.2',
          address_id: '415000000789012',
          addr1: '4706 RAMHORN KILLEEN TX 76542',
          addr1_lat: 31.058969497680664,
          addr1_long: -97.68914795,
        });
      } else if (transaction.id === 3) {
        setTransactionDesignDetails({
          row_id: 140029902,
          address_id: '140029902418122',
          status: 'success',
          cost: 0,
          flowerpots: 0,
          fp_id: 'FP001',
          map_url: '',
          building_id: 299022,
          converted_image: OtterImg,
          imagebase64: '',
          version_id: 1,
          is_current: true,
          summary_date: 'N/A'
        });
        setTerminalAddressDetails({
          row_num: 3,
          ticket_id: 'IQ-313161',
          terminal_id: 'TML.002.05.04.1.1',
          address_id: '140029902418122',
          addr1: '1059 OTTER CIR BEAUFORT SC 29902',
          addr1_lat: 32.412952,
          addr1_long: -80.717606,
        });
      } else if (transaction.id === 4) {
        setTransactionDesignDetails({
          row_id: 140029902414,
          address_id: '140029902414312',
          status: 'success',
          cost: 0,
          flowerpots: 0,
          fp_id: 'FP001',
          map_url: '',
          building_id: 299022,
          converted_image: WolverineImg,
          imagebase64: '',
          version_id: 1,
          is_current: true,
          summary_date: 'N/A'
        });
        setTerminalAddressDetails({
          row_num: 4,
          ticket_id: 'IQ-313176',
          terminal_id: 'TML.002.05.04.5.2',
          address_id: '140029902414312',
          addr1: '1013 WOLVERINE DR BEAUFORT SC 29902',
          addr1_lat: 32.415283,
          addr1_long: -80.714874,
        });
      } else if (transaction.id === 5) {
        setTransactionDesignDetails({
          row_id: 147576542319,
          address_id: '147576542319621',
          status: 'success',
          cost: 0,
          flowerpots: 0,
          fp_id: 'FP001',
          map_url: '',
          building_id: 765422,
          converted_image: TourmalineKilleenImg,
          imagebase64: '',
          version_id: 1,
          is_current: true,
          summary_date: 'N/A'
        });
        setTerminalAddressDetails({
          row_num: 5,
          ticket_id: 'IQ-313089',
          terminal_id: 'TML.003.05a.03.1.3',
          address_id: '147576542319621',
          addr1: '5616 TOURMALINE DR KILLEEN TX 76542',
          addr1_lat: 31.051597,
          addr1_long: -97.691823,
        });
      }
    }
  };

  // Close right panel
  const handleClosePanel = () => {
    setRightPanelOpen(false);
    setSelectedTransaction(null);
    setTransactionDesignDetails(null);
    setTerminalAddressDetails(null);
    setActiveTab(0);
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Remove API: simple stub to keep type consistency
  const fetchTransactionDetails = async () => { setDetailsLoading(false); };

  const handleDownloadClick = () => {
    alert("Download functionality will be implemented when backend is ready!");
  };

  const handleRetry = () => {
    setError(null);
  };

const handleSubmitAction = async (transactionId) => {
  // If already processing or processed, ignore
  if (submittingTransactions.has(transactionId) || processedTransactions.has(transactionId)) return;

  // Simulate processing delay between 15-20 seconds
  const delayMs = (15 + Math.floor(Math.random() * 6)) * 1000;

  setSubmittingTransactions(prev => {
    const s = new Set(prev);
    s.add(transactionId);
    return s;
  });

  setTimeout(() => {
    setProcessedTransactions(prev => {
      const s = new Set(prev);
      s.add(transactionId);
      return s;
    });
    setTransactions(prev => prev.map(t => t.id === transactionId ? { ...t, status: 'Processed' } : t));
    // Auto-open right panel only after processed
    const processed = transactions.find(t => t.id === transactionId);
    if (processed) {
      handleRowClick(transactionId);
    }
    setSubmittingTransactions(prev => {
      const s = new Set(prev);
      s.delete(transactionId);
      return s;
    });
  }, delayMs);
};

  const filteredTransactions = transactions.filter(transaction =>
    transaction.ticket_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    transaction.address_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    transaction.order_number?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    transaction.terminal_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    transaction.full_address?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredTransactions.length / transactionsPerPage);
  const indexOfLastTransaction = page * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = filteredTransactions.slice(indexOfFirstTransaction, indexOfLastTransaction);

  // Use only real rows; no padding rows
  const rowsToShow = currentTransactions;

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to first page when searching
  };

  return (
    <Box sx={{ background: "#faf9f6", minHeight: "100vh" }}>
      <Navbar />

      {/* Spacing below navbar */}
      <Box sx={{ py: 2 }} />

      {/* Date Range Filter and Search Bar */}
      <Box sx={{ px: { xs: 2, md: 4 }, py: 1, maxWidth: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        {/* Date Filter Section - Left Side */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <TextField
            type="date"
            label="Start Date"
            value={startDate || ''}
            onChange={(e) => setStartDate(e.target.value)}
            size="small"
            sx={{ minWidth: 150 }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            type="date"
            label="End Date"
            value={endDate || ''}
            onChange={(e) => setEndDate(e.target.value)}
            size="small"
            sx={{ minWidth: 150 }}
            InputLabelProps={{ shrink: true }}
          />
          <Button
            variant="contained"
            onClick={() => {
              setStartDate('');
              setEndDate('');
            }}
            sx={{
               backgroundColor: '#42a5f5', 
               color: '#0d1b2a', 
               '&:hover': { backgroundColor: '#1e88e5', color: '#fff' },
              fontWeight: 600
            }}
          >
            Clear Filter
          </Button>
        </Box>

        {/* Search Bar Section - Right Side */}
          <TextField
            placeholder="Search by Order #,Ticket ID and Address ID"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              minWidth: 400,
              '& .MuiOutlinedInput-root': {
               '&:hover fieldset': { borderColor: '#64b5f6' },
               '&.Mui-focused fieldset': { borderColor: '#1e88e5' },
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#1a1a1a' }} />
                </InputAdornment>
              ),
            }}
          />
      </Box>

      {/* Summary Dashboard Section */}
      <Box sx={{ px: { xs: 2, md: 4 }, py: 1, maxWidth: '100%', maxHeight: '30vh' }}>
        <Typography variant="body1" sx={{ mb: 1, fontWeight: 700, color: '#1a1a1a', textAlign: 'center', letterSpacing: 0.2 }}>
          Summary Dashboard
        </Typography>

        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'nowrap', overflowX: 'auto', justifyContent: 'center' }}>
          {/* Input Count KPI */}
          <Card sx={{
             background: 'linear-gradient(135deg, #90caf9 0%, #64b5f6 100%)',
             color: '#0d1b2a',
            minWidth: 120,
            minHeight: 80,
            flex: 1
          }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center', height: '100%', pt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, fontSize: '1.25rem' }}>
                  {summaryKPIs.totalInputCount || 0}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <InputIcon sx={{ fontSize: 12, opacity: 0.8 }} />
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Total Input Records
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Tickets Processed KPI */}
          <Card sx={{
             background: 'linear-gradient(135deg, #90caf9 0%, #64b5f6 100%)',
             color: '#0d1b2a',
            minWidth: 120,
            minHeight: 80,
            flex: 1
          }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center', height: '100%', pt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, fontSize: '1.25rem' }}>
                  {summaryKPIs.totalProcessCount || 0}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <CheckCircleIcon sx={{ fontSize: 12, opacity: 0.8 }} />
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Tickets Processed
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Total Tickets KPI */}
          <Card sx={{
             background: 'linear-gradient(135deg, #bbdefb 0%, #90caf9 100%)',
             color: '#0d1b2a',
            minWidth: 120,
            minHeight: 80,
            flex: 1
          }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center', height: '100%', pt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, fontSize: '1.25rem' }}>
                  {summaryKPIs.totalTickets || 0}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <TrendingUpIcon sx={{ fontSize: 12, opacity: 0.8 }} />
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Total Tickets
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Average Processing Time KPI */}
          <Card sx={{
             background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
             color: '#0d1b2a',
            minWidth: 120,
            minHeight: 80,
            flex: 1
          }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center', height: '100%', pt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, fontSize: '1.25rem' }}>
                  {summaryKPIs.avgProcessingTime || 32}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <TimerIcon sx={{ fontSize: 12, opacity: 0.8 }} />
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Avg Processing (sec)
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Failed Tickets KPI */}
          <Card sx={{
             background: 'linear-gradient(135deg, #90caf9 0%, #64b5f6 100%)',
             color: '#0d1b2a',
            minWidth: 120,
            minHeight: 80,
            flex: 1
          }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center', height: '100%', pt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, fontSize: '1.25rem' }}>
                  {summaryKPIs.totalFailed || 0}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <ErrorIcon sx={{ fontSize: 12, opacity: 0.8 }} />
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Failed Tickets
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>

      {/* Spacing between Summary Dashboard and Transaction Table */}
      <Box sx={{ py: 2 }} />

      {error && (
        <Box sx={{ px: 4, mb: 2 }}>
          <Alert severity="error" action={<Button color="inherit" size="small" onClick={handleRetry}>RETRY</Button>}>
            {error}
          </Alert>
        </Box>
      )}

      <Box sx={{ px: { xs: 1, md: 4 } }}>
        <Paper elevation={3} sx={{ borderRadius: 2 }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ background: "#64b5f6" }}>
                  <TableCell sx={{ fontWeight: 500 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Ticket ID</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Due Date</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Address ID</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Full Address</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Received TS</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={12} align="center"><Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><CircularProgress /><Typography sx={{ ml: 2 }}>Loading transactions...</Typography></Box></TableCell></TableRow>
                ) : rowsToShow.length > 0 ? (
                  rowsToShow.map((item) => (
                    <TableRow
                      key={item.id}
                      hover={!item.isEmpty}
                      sx={{
                        cursor: item.isEmpty ? "default" : "pointer",
                        "&:hover": { backgroundColor: item.isEmpty ? "transparent" : "#f5f5f5" },
                        height: "18px" // Ultra compact height for both filled and empty rows
                      }}
                      onClick={item.isEmpty ? undefined : () => handleRowClick(item.id)}
                    >
                      <TableCell sx={{ height: "18px" }}>{item.isEmpty ? '\u00A0' : item.id}</TableCell>
                      <TableCell sx={{ height: "18px" }}>{item.isEmpty ? '\u00A0' : item.ticket_id}</TableCell>
                      <TableCell sx={{ height: "18px" }}>{item.isEmpty ? '\u00A0' : (item.bsw_due_date ? String(item.bsw_due_date).split(' ')[0] : '')}</TableCell>
                      <TableCell sx={{ height: "18px" }}>{item.isEmpty ? '\u00A0' : item.address_id}</TableCell>
                      <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', height: "18px" }}>{item.isEmpty ? '\u00A0' : item.full_address}</TableCell>
                      <TableCell sx={{ height: "18px" }}>{item.isEmpty ? '\u00A0' : item.received_date_time}</TableCell>
                      <TableCell sx={{ height: "18px" }}>
                        {item.isEmpty ? '\u00A0' : (
                          <Box sx={{
                            display: 'inline-block',
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            backgroundColor: submittingTransactions.has(item.id) ? '#90caf9' : (item.status === 'Processed' ? '#81c784' : '#ffcc80'),
                            color: '#1a1a1a',
                            fontSize: '0.75rem',
                            fontWeight: 400
                          }}>
                            {submittingTransactions.has(item.id) ? 'Processing…' : item.status}
                          </Box>
                        )}
                      </TableCell>
                      <TableCell sx={{ height: "18px" }}>
                        {item.isEmpty ? '\u00A0' : (
                          <Button
                            variant="contained"
                            size="small"
                            disabled={submittingTransactions.has(item.id)}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSubmitAction(item.id);
                            }}
                            sx={{
                              backgroundColor: '#42a5f5',
                              color: '#0d1b2a',
                              '&:hover': { backgroundColor: '#1e88e5', color: '#fff' },
                              '&:disabled': { backgroundColor: '#90caf9', color: '#1a1a1a' },
                              fontSize: '0.7rem',
                              py: 0.5,
                              px: 1,
                              minWidth: 60
                            }}
                          >
                            {submittingTransactions.has(item.id) ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <CircularProgress size={14} color="inherit" />
                                <span>Processing…</span>
                              </Box>
                            ) : (
                              'Process'
                            )}
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow><TableCell colSpan={12} align="center"><Typography sx={{ py: 2 }}>{searchQuery ? `No transactions found matching "${searchQuery}".` : "No transactions found."}</Typography></TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {filteredTransactions.length > transactionsPerPage && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, borderTop: '1px solid #e0e0e0' }}>
              <Pagination count={totalPages} page={page} onChange={handlePageChange} renderItem={(item) => (
                <PaginationItem components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }} sx={{ '&.Mui-selected': { backgroundColor: '#64b5f6', color: '#0d1b2a', fontWeight: 'bold', '&:hover': { backgroundColor: '#42a5f5', color: '#fff' } }, '& .MuiPaginationItem-icon': { color: '#1a1a1a' } }} {...item} />
              )} />
              <Typography sx={{ ml: 2, color: '#1a1a1a' }}>Page {page} of {totalPages}</Typography>
            </Box>
          )}
        </Paper>
      </Box>

      {/* Right Panel with Transaction Details */}
      <Drawer
        anchor="right"
        open={rightPanelOpen}
        onClose={handleClosePanel}
        sx={{
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: 600, md: 700 },
            background: '#faf9f6',
          },
        }}
      >
        {selectedTransaction && (
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Box sx={{
              p: 2,
              background: '#90caf9', 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e0e0e0'
            }}>
              <Typography variant="h6" sx={{ fontWeight: 500, color: '#1a1a1a' }}>
                Transaction Details
              </Typography>
              <IconButton onClick={handleClosePanel} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Transaction Summary */}
            <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                {selectedTransaction.ticket_id} - {selectedTransaction.terminal_id}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {selectedTransaction.full_address}
              </Typography>
            </Box>

            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                sx={{
                  '& .MuiTab-root': {
                    color: '#1a1a1a',
                    fontWeight: 500,
                    '&.Mui-selected': {
                      color: '#1976d2',
                      fontWeight: 600,
                    },
                  },
                  '& .MuiTabs-indicator': {
                        backgroundColor: '#1976d2',
                  },
                }}
              >
                <Tab label="Design" />
                <Tab label="Design Details" />
                <Tab label="Terminal Address Details" />
              </Tabs>
            </Box>

            {/* Tab Content */}
            <Box sx={{ flex: 1, overflow: 'auto' }}>
              {detailsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {/* Design Tab - Display image from API results */}
                  <TabPanel value={activeTab} index={0}>
                    <Typography variant="h6" sx={{ mb: 2, color: '#1a1a1a', fontWeight: 500 }}>
                      Design Image
                    </Typography>
                    <Card sx={{ position: 'relative' }}>
                      <CardContent>
                        {transactionDesignDetails ? (
                            <Box>
                            {/* Display the image */}
                            {transactionDesignDetails.converted_image ? (
                                <Box sx={{
                                  width: '100%',
                                  height: 400,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: 1,
                                  overflow: 'hidden'
                                }}>
                                  <img
                                  src={transactionDesignDetails.converted_image} 
                                    alt="Design Image"
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '350px',
                                      objectFit: 'contain'
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                      e.target.nextSibling.style.display = 'block';
                                    }}
                                  
                                  />
                                  <Typography
                                    variant="body2"
                                    color="error"
                                    sx={{ display: 'none', textAlign: 'center', mt: 2 }}
                                  >
                                    Failed to load converted image
                                  </Typography>
                                </Box>
                            ) : transactionDesignDetails.imagebase64 ? (
                                <Box sx={{
                                  width: '100%',
                                height: 400, 
                                  display: 'flex',
                                flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                border: '1px solid #e0e0e0',
                                  borderRadius: 1,
                                overflow: 'hidden'
                              }}>
                                <img 
                                  src={transactionDesignDetails.imagebase64} 
                                  alt="Design Image" 
                                  style={{ 
                                    maxWidth: '100%', 
                                    maxHeight: '350px', 
                                    objectFit: 'contain' 
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                  }}
                                />
                                <Typography 
                                  variant="body2" 
                                  color="error" 
                                  sx={{ display: 'none', textAlign: 'center', mt: 2 }}
                                >
                                  Failed to load base64 image
                                  </Typography>
                                </Box>
                              ) : (
                                <Box sx={{
                                  width: '100%',
                                  height: 300,
                                  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: 1,
                                  border: '2px dashed #ccc'
                                }}>
                                  <Typography variant="body2" color="text.secondary">
                                    No design image available for this transaction
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                        ) : (
                          <Box sx={{ 
                            width: '100%', 
                            height: 300, 
                            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            borderRadius: 1,
                            border: '2px dashed #ccc'
                          }}>
                            <Typography variant="body2" color="text.secondary">
                              Loading design image...
                            </Typography>
                          </Box>
                        )}
                      </CardContent>
                      {/* Enlarge control in top-right of card */}
                      <Box sx={{ position: 'absolute', top: 6, right: 6 }}>
                        <IconButton aria-label="Enlarge" size="small" onClick={() => setImageDialogOpen(true)} sx={{ backgroundColor: '#42a5f5', color: '#0d1b2a', p: 0.5, '&:hover': { backgroundColor: '#1e88e5', color: '#fff' } }}>
                          <ZoomInIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Box>
                    </Card>
                  </TabPanel>

              {/* Fullscreen Image Dialog */}
              <Dialog open={imageDialogOpen} onClose={() => setImageDialogOpen(false)} maxWidth={false}>
                <DialogContent sx={{ p: 0 }}>
                  <Box sx={{ background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {transactionDesignDetails?.converted_image && (
                      <img src={transactionDesignDetails.converted_image} alt="Design Full" style={{ maxWidth: '90vw', maxHeight: '90vh' }} />
                    )}
                    {!transactionDesignDetails?.converted_image && transactionDesignDetails?.imagebase64 && (
                      <img src={transactionDesignDetails.imagebase64} alt="Design Full" style={{ maxWidth: '90vw', maxHeight: '90vh' }} />
                    )}
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setImageDialogOpen(false)} variant="contained">Close</Button>
                </DialogActions>
              </Dialog>

                  {/* Design Details Tab */}
                  <TabPanel value={activeTab} index={1}>
                    <Typography variant="h6" sx={{ mb: 2, color: '#1a1a1a', fontWeight: 500 }}>
                      Transaction Design Details
                    </Typography>
                    <Card>
                      <CardContent>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Row ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.row_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.address_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Status:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.status || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Flowerpots:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.flowerpots !== undefined ? transactionDesignDetails.flowerpots : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Flowerpot ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.fp_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Map URL:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.map_url ? (
                                <a href={transactionDesignDetails.map_url} target="_blank" rel="noopener noreferrer" style={{ color: '#1a1a1a' }}>
                                  {transactionDesignDetails.map_url}
                                </a>
                              ) : (
                                'N/A'
                              )}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Building ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.building_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Converted Image:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.converted_image ? (
                                <a href={transactionDesignDetails.converted_image} target="_blank" rel="noopener noreferrer" style={{ color: '#1a1a1a' }}>
                                  {transactionDesignDetails.converted_image}
                                </a>
                              ) : (
                                'N/A'
                              )}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Image Base64:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {transactionDesignDetails?.imagebase64 ?
                                `${transactionDesignDetails.imagebase64.substring(0, 50)}...` : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Version ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.version_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Is Current:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.is_current !== undefined ? (transactionDesignDetails.is_current ? 'Yes' : 'No') : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Summary Date:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {transactionDesignDetails?.summary_date || 'N/A'}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </TabPanel>

                  {/* Terminal Address Tab */}
                  <TabPanel value={activeTab} index={2}>
                    <Typography variant="h6" sx={{ mb: 2, color: '#1a1a1a', fontWeight: 500 }}>
                      Terminal Address Details
                    </Typography>
                    <Card>
                      <CardContent>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Row Number:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.row_num || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Ticket ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.ticket_id || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Terminal ID:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.terminal_id || 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 1 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 1:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr1 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 1 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr1_lat ? terminalAddressDetails.addr1_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 1 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr1_long ? terminalAddressDetails.addr1_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 2 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 2:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr2 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 2 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr2_lat ? terminalAddressDetails.addr2_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 2 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr2_long ? terminalAddressDetails.addr2_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 3 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 3:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr3 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 3 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr3_lat ? terminalAddressDetails.addr3_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 3 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr3_long ? terminalAddressDetails.addr3_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 4 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 4:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr4 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 4 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr4_lat ? terminalAddressDetails.addr4_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 4 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr4_long ? terminalAddressDetails.addr4_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 5 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 5:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr5 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 5 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr5_lat ? terminalAddressDetails.addr5_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 5 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr5_long ? terminalAddressDetails.addr5_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 6 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 6:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr6 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 6 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr6_lat ? terminalAddressDetails.addr6_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 6 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr6_long ? terminalAddressDetails.addr6_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 7 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 7:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr7 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 7 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr7_lat ? terminalAddressDetails.addr7_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 7 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr7_long ? terminalAddressDetails.addr7_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          {/* Address 8 */}
                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 8:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr8 || 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 8 Latitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr8_lat ? terminalAddressDetails.addr8_lat.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', py: 1, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a', minWidth: 220, textAlign: 'left', pr: 2 }}>
                              Address 8 Longitude:
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1a1a1a' }}>
                              {terminalAddressDetails?.addr8_long ? terminalAddressDetails.addr8_long.toFixed(6) : 'N/A'}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </TabPanel>
                </>
              )}
            </Box>
          </Box>
        )}
      </Drawer>
    </Box>
  );
}
